import { ArrowRight } from "lucide-react";
import { Rings } from "./decor";
import { PROBLEMS } from "../data";
import { Reveal, SectionLabel } from "./primitives";

export const Problem = () => (
  <section id="problem" data-testid="problem-section" className="relative isolate overflow-hidden bg-white py-24 md:py-32">
    <Rings className="right-[-40px] top-12 h-64 w-64 opacity-70" />
    <div className="mx-auto max-w-7xl px-6 md:px-8">
      <Reveal>
        <SectionLabel>The Gap</SectionLabel>
        <h2 className="mt-4 max-w-3xl font-serif text-3xl font-medium tracking-tight text-[#23271F] sm:text-4xl lg:text-5xl">
          Most Indian tech & services firms are leaving enterprise revenue on the table.
        </h2>
      </Reveal>

      <div className="mt-16 grid gap-6 md:grid-cols-3">
        {PROBLEMS.map((p, i) => (
          <Reveal key={i} delay={i * 0.1}>
            <div className="group h-full rounded-2xl border border-line bg-white shadow-[0_6px_28px_rgba(28,38,18,0.06)] p-8 transition-transform duration-300 hover:-translate-y-1 hover:border-brand/40">
              <div className="mb-6 flex items-center gap-3">
                <span className="grid h-8 w-8 place-items-center rounded-full border border-line text-xs font-semibold text-[#77806a]">
                  0{i + 1}
                </span>
                <span className="h-px flex-1 bg-line" />
              </div>
              <h3 className="font-serif text-xl font-medium text-[#23271F]">{p.pain}</h3>
              <div className="my-5 flex items-center gap-2 text-[#5C8A1E]">
                <span className="text-[11px] font-semibold uppercase tracking-[0.18em]">The XSELL reframe</span>
                <ArrowRight className="h-3.5 w-3.5" />
              </div>
              <p className="text-sm leading-relaxed text-[#535b4b]">{p.reframe}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
